import React from 'react';
import { MultiValue } from 'react-select';
import EpdSelectComponent from 'components/form/EpdSelectComponent';
import SmartLabel from 'components/v2/labels/SmartLabel';
import { useDynamicFormsDocumentCollections, useEpdCollectionsLookup } from 'services/api/queries';
import { useUpdateDocumentCollections } from 'services/api/mutations';
import { Option } from 'types/types';
import { DocumentActionState } from 'types/dynamic-forms/DocumentModelStateActions';
import { useDocumentStore } from '../hooks/useDocumentStore';

const DocumentCollectionsRenderer: React.FC = () => {
  const { metadata, docId, state } = useDocumentStore();
  const collectionsLookup = useEpdCollectionsLookup(metadata.companyId);
  const documentCollections = useDynamicFormsDocumentCollections(docId);
  const updateDocumentCollections = useUpdateDocumentCollections(docId);
  const collectionOptions = collectionsLookup.data ?? [];
  const selectedCollections = collectionOptions.filter((option) =>
    documentCollections.data?.some((collection) => collection.id === option.value)
  );
  const canEditCollections = state.actions.editCollections === DocumentActionState.Enabled;

  const changeCollections = (selected: MultiValue<Option>) => {
    updateDocumentCollections.mutate(selected.map((option) => option.value));
  };

  return (
    <div>
      <SmartLabel label="Collection(s)" tooltip="The EPD collections of your company that this EPD belongs to." />
      <EpdSelectComponent
        options={collectionOptions}
        isMulti
        value={selectedCollections}
        onChange={changeCollections}
        isDisabled={
          !canEditCollections ||
          collectionsLookup.isLoading ||
          documentCollections.isLoading ||
          updateDocumentCollections.isPending
        }
      />
    </div>
  );
};

export default DocumentCollectionsRenderer;
